import { useState, useEffect } from "react";
import combinedServices from "../../../../shared/services/user-service";
import Swal from "sweetalert2";
import RichTextEditor from "react-rte";
import {
    RichTextEditorComponent,
    Toolbar,
    Link,
    QuickToolbar,
    HtmlEditor,
    Inject,
} from "@syncfusion/ej2-react-richtexteditor";
import { Image as SyncfusionImage } from "@syncfusion/ej2-react-richtexteditor";
import userConstants from "../../../../shared/constants/user-constants";

const NoticeBoard = ({
    storeId
}) => {

    const [noticeExist, setNoticeExist] = useState(null);
    const [noticeContent, setNoticeContent] = useState("");
    const [noticeStatus, setNoticeStatus] = useState("inactive");
    const [imageUrl, setImageUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [baseURL, setBaseUrl] = useState(userConstants.baseURL);

    useEffect(() => {
        const fetchNotice = async () => {
            try {
                const noticeExistResp = await combinedServices.fetchNoticeById(storeId);
                if (noticeExistResp.data.status==200) {
                    setNoticeExist(true);
                    setNoticeContent(noticeExistResp.data.data.content);
                    setNoticeStatus(noticeExistResp.data.data.notice_status);
                } else {
                    setNoticeExist(false);
                }
            } catch (error) {
                console.log("Error fetching notices");
                setNoticeExist(false);
            }
        }
        fetchNotice();
    }, [
        storeId
    ])

    const handleNoticeSave = async () => {
        try {
            if (noticeExist == true) {
                const response = await combinedServices.updateNoticeContent({
                    store_id: storeId,
                    content: noticeContent
                })
                if (response.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Notice Updated Successfully!",
                        text: `Notice has been saved to the database.`,
                    });
                }
            } else if (noticeExist == false) {
                const response = await combinedServices.createNoticeForStore({
                    store_id: storeId,
                    content: noticeContent
                })
                if (response.data.status == 201) {
                    Swal.fire({
                        icon: "success",
                        title: "Notice Created Successfully!",
                        text: `Notice has been saved to the database.`,
                    });
                    setNoticeExist(true);
                    setNoticeStatus("active");
                }
            } else {
                return;
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: "error",
                title: "Error Saving Notice",
                text: "Failed to save notice. Please try again!!",
            });
        } finally {
            setLoading(false);
        }

    }

    const handleStatusChange = async (newStatus) => {
        try {
            const response = await combinedServices.changeNoticeStatus({
                id: storeId,
                notice_status: newStatus
            });
            if (response.status == 200) {
                setNoticeStatus(newStatus);
                Swal.fire({
                    icon: "success",
                    title: "Status Updated Successfully!",
                    text: `Notice status has been updated to ${newStatus}.`,
                });
            }

        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: "error",
                title: "Error Saving Status",
                text: "Failed to save status. Please try again!!",
            });
        } finally {
            setLoading(false);
        }
    }

    const toolbarSettings = {
        items: [
            "Bold",
            "Italic",
            "Underline",
            "StrikeThrough",
            "FontName",
            "FontSize",
            "FontColor",
            "BackgroundColor",
            "LowerCase",
            "UpperCase",
            "|",
            "Formats",
            "Alignments",
            "OrderedList",
            "UnorderedList",
            "Outdent",
            "Indent",
            "|",
            "CreateLink",
            "Image",
            "|",
            "ClearFormat",
            "Print",
            "SourceCode",
            "FullScreen",
            "|",
            "Undo",
            "Redo",
        ],
    };
    const quickToolbarSettings = {
        table: [
            "TableHeader",
            "TableRows",
            "TableColumns",
            "TableCell",
            "-",
            "BackgroundColor",
            "TableRemove",
            "TableCellVerticalAlign",
            "Styles",
        ],
        image: [
            "Replace",
            "Align",
            "Caption",
            "Remove",
            "InsertLink",
            "OpenImageLink",
            "-",
            "EditImageLink",
            "RemoveImageLink",
            "Display",
            "AltText",
            "Dimension",
        ],
        link: ["Open", "Edit", "UnLink"],
    };
    const saveContent = (e) => {
        // Create a temporary DOM element to work with the HTML content
        const tempElement = document.createElement("div");
        tempElement.innerHTML = e.value;

        // Loop through all the images in the content
        const images = tempElement.querySelectorAll("img");
        images.forEach((img) => {
            // Check if the image has a blob URL
            if (img.src.startsWith("blob:")) {
                // Replace the blob URL with the actual image URL
                img.src = imageUrl; // Replace with your actual image URL
            }
        });

        // Convert the modified HTML content back to a string and update the editor data
        const modifiedContent = tempElement.innerHTML;
        setNoticeContent(modifiedContent);
    };
    const insertImageSettings = {
        saveUrl:
            "https://services.syncfusion.com/js/production/api/FileUploader/Save",
        removeUrl:
            "https://services.syncfusion.com/js/production/api/FileUploader/Remove",
        height: 165,
        width: 165,
    };
    const imageUploadHandler = async (args) => {
        try {
            const files = args.file.rawFile;
            const formData = new FormData();
            formData.append("image", files);

            const response = await combinedServices.uploadImage(formData);
            const imageUrl =
                (await baseURL) + "images/" + response.data.data.file_name;

            // Create a new image element
            const imageElement = document.createElement("img");
            imageElement.setAttribute("src", imageUrl);
            imageElement.setAttribute("alt", "Uploaded Image");
            imageElement.setAttribute("width", "165px"); // Adjust as needed
            imageElement.setAttribute("height", "165px"); // Adjust as needed
            setImageUrl(imageUrl);
            // Create a new paragraph element
            const paragraph = document.createElement("p");
            paragraph.appendChild(imageElement);

            // Append the new paragraph to the current editor content
            const updatedContent = noticeContent + paragraph.outerHTML;
            setNoticeContent(updatedContent);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className="noticeBoard">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Notice Board</h4>
                    <button
                        className="nambaBtn"
                        onClick={handleNoticeSave}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : (noticeExist ? "Update Notice" : "Create Notice")}
                    </button>
                </div>
                {noticeExist && (
                    <div className="statusSection mb-3">
                        <div className="card p-3">
                            <h6 className="mb-3">Notice Status</h6>
                            <div className="d-flex gap-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="noticeStatus"
                                        id="statusActive"
                                        value="active"
                                        checked={noticeStatus === "active"}
                                        onChange={(e) => handleStatusChange(e.target.value)}
                                        disabled={loading}
                                    />
                                    <label className="form-check-label" htmlFor="statusActive">
                                        <span className="badge bg-success">Active</span>
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="noticeStatus"
                                        id="statusInactive"
                                        value="inactive"
                                        checked={noticeStatus === "inactive"}
                                        onChange={(e) => handleStatusChange(e.target.value)}
                                        disabled={loading}
                                    />
                                    <label className="form-check-label" htmlFor="statusInactive">
                                        <span className="badge bg-secondary">Inactive</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="editorSection">
                    <div className="card">
                        <div className="card-body">
                            <RichTextEditorComponent
                                height={300}
                                width={800}
                                toolbarSettings={toolbarSettings}
                                quickToolbarSettings={quickToolbarSettings}
                                value={noticeContent}
                                change={saveContent}
                                imageUploadSuccess={imageUploadHandler}
                                insertImageSettings={insertImageSettings}
                            >
                                <Inject
                                    services={[
                                        Toolbar,
                                        SyncfusionImage,
                                        Link,
                                        HtmlEditor,
                                        QuickToolbar,
                                    ]}
                                />
                            </RichTextEditorComponent>

                        </div>
                    </div>
                </div>

                <div className="mt-3">
                    <small className="text-muted">
                        {noticeExist
                            ? "Notice exists. You can update the content and status above."
                            : "No notice found. Create a new notice by adding content and clicking 'Create Notice'."
                        }
                    </small>
                </div>
            </div>

        </>
    );
}

export default NoticeBoard;